import { SubGameType } from "types/game";

import { CATEGORY_CODE } from "./type";
import { ProviderLogo } from "assets/desktop/images/providerList";
import { ImgProvider } from "assets/desktop/images/navSubgame";

export const listSlots: SubGameType[] = [
  {
    game_code: "",
    name: "ATG",
    provider_code: "ATG",
    provider_name: "ATG SLOT",
    type: CATEGORY_CODE.GAMES,
    featured: "",
    new_arrive: "",
    picture: ImgProvider.SlotATG,
    icon: ProviderLogo.ATG,
  },
  {
    game_code: "",
    name: "RSG",
    provider_code: "RSG",
    provider_name: "RSG SLOT",
    type: CATEGORY_CODE.GAMES,
    featured: "",
    new_arrive: "",
    picture: ImgProvider.SlotRSG,
    icon: ProviderLogo.RSG,
  },
  {
    game_code: "",
    name: "GR",
    provider_code: "GR",
    provider_name: "GR SLOT",
    type: CATEGORY_CODE.GAMES,
    featured: "",
    new_arrive: "",
    picture: ImgProvider.SlotGR,
    icon: ProviderLogo.GR,
  },
  {
    game_code: "",
    name: "ZG",
    provider_code: "ZG",
    provider_name: "ZEBRA SLOT",
    type: CATEGORY_CODE.GAMES,
    featured: "",
    new_arrive: "",
    picture: ImgProvider.SlotZG,
    icon: ProviderLogo.ZG,
  },
  {
    game_code: "",
    name: "DT",
    provider_code: "DT",
    provider_name: "DT SLOT",
    type: CATEGORY_CODE.GAMES,
    featured: "",
    new_arrive: "",
    picture: ImgProvider.SlotDT,
    icon: ProviderLogo.DT,
  },
  {
    game_code: "",
    name: "PMSL",
    provider_code: "PMSL",
    provider_name: "DB SLOT",
    type: CATEGORY_CODE.GAMES,
    featured: "",
    new_arrive: "",
    picture: ImgProvider.SlotDB,
    icon: ProviderLogo.DB,
  },
  {
    game_code: "",
    name: "RTG",
    provider_code: "RTG",
    provider_name: "RTG SLOT",
    type: CATEGORY_CODE.GAMES,
    featured: "",
    new_arrive: "",
    picture: ImgProvider.SlotRTG,
    icon: ProviderLogo.RTG,
  },
  {
    game_code: "",
    name: "BNG",
    provider_code: "BNG",
    provider_name: "BNG SLOT",
    type: CATEGORY_CODE.GAMES,
    featured: "",
    new_arrive: "",
    picture: ImgProvider.SlotBNG,
    icon: ProviderLogo.BNG,
  },
];
